/* PATOYS WhatsApp: adds product / page context to wa.me/<store number> links at click time. No dependencies. */
(function () {
  var el = document.getElementById('pt-wa-data');
  if (!el) return;
  var d;
  try { d = JSON.parse(el.textContent); } catch (e) { return; }
  var NUM = '918010110811';

  function context() {
    if (!d.title) return { text: d.generic, tail: location.origin + location.pathname };
    var vid = new URLSearchParams(location.search).get('variant') || String(d.variant);
    var url = d.url + (new URLSearchParams(location.search).get('variant') ? '?variant=' + vid : '');
    var price = d.prices[vid] || d.prices[String(d.variant)];
    return {
      text: d.interested.replace('@@T@@', d.title),
      tail: (price ? '₹' + price + ' – ' : '') + url
    };
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/' + NUM + '"]');
    if (!a) return;
    var u;
    try { u = new URL(a.href); } catch (err) { return; }
    var text = u.searchParams.get('text');
    if (text && /https?:\/\//.test(text)) return; // already carries a link (e.g. product cards)
    var c = context();
    var msg = text ? text + ' – ' + c.tail : c.text + (d.title ? ' – ' : ' ') + c.tail;
    u.searchParams.set('text', msg);
    a.href = u.toString();
  }, true);
})();
